var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { SystemIcon } from '@storeblocks/icon';
import { formatCell, generateRowKey } from '../utils';
import { BorderlessRow, Cell, ChevronContainer, IndentedCell, IndentedCellWithChevron, IndentedCellWrapper, } from '../styled';
export function ExpandableRow(_a) {
    var _b;
    var { columns, row: rowObj, depth = 0, expanded } = _a, props = __rest(_a, ["columns", "row", "depth", "expanded"]);
    const [isOpen, setIsOpen] = useState(expanded);
    const handleClick = () => {
        setIsOpen(!isOpen);
    };
    function renderCells(row, hasSubRows) {
        // eslint-disable-next-line unused-imports/no-unused-vars
        const { subRows } = row, rest = __rest(row, ["subRows"]);
        return Object.keys(rest).map((rowPropertyKey, cellIndex) => {
            const column = columns[cellIndex];
            const rowKey = column.dataType === 'other' ? row[rowPropertyKey].key : row.title;
            const cellKey = `cell-${column.key}-${rowKey}`;
            if (cellIndex === 0) {
                if (hasSubRows) {
                    return (React.createElement(IndentedCellWithChevron, { key: cellKey, style: column.style, depth: depth },
                        React.createElement(IndentedCellWrapper, null,
                            React.createElement(ChevronContainer, { className: isOpen ? 'up' : 'down', onClick: () => handleClick() },
                                React.createElement(SystemIcon, { name: "chevron-down", size: 16, "aria-label": isOpen ? 'collapse' : 'expand' })),
                            formatCell(row, column))));
                }
                return (React.createElement(IndentedCell, { key: cellKey, style: column.style, depth: depth === 0 ? depth + 1 : depth }, formatCell(row, column)));
            }
            return (React.createElement(Cell, { key: cellKey, style: column.style }, formatCell(row, column)));
        });
    }
    if (((_b = rowObj.subRows) === null || _b === void 0 ? void 0 : _b.length) > 0) {
        const { subRows } = rowObj;
        // Generate keys to be used as HTML element ID and React key.
        // Replaced whitespace with a dash as it is used as HTML element ID.
        const ids = subRows.map((subRow) => generateRowKey(subRow, columns).replace(/\s/g, '-'));
        return (React.createElement(React.Fragment, null,
            React.createElement(BorderlessRow, Object.assign({ "aria-expanded": isOpen, "aria-controls": ids.join(' ') }, props), renderCells(rowObj, true)),
            isOpen &&
                subRows.map((subRow, i) => (React.createElement(ExpandableRow, { key: ids[i], id: ids[i], columns: columns, row: subRow, depth: depth + 1, expanded: expanded })))));
    }
    return (React.createElement(BorderlessRow, Object.assign({ key: generateRowKey(rowObj, columns) }, props), renderCells(rowObj, false)));
}
